export enum PhotoUploadErrors {
  TOO_BIG = "Request body too large",
  WRONG_FILE_TYPE = "Unable to verify file contents",
  OFFLINE = "Offline",
  DEFAULT_ERROR = "An error has occured saving image to API"
}

export const getPhotoValidationErrorFromMessage = (errorMessage: string) => {
  if (errorMessage?.includes(PhotoUploadErrors.TOO_BIG)) {
    return PhotoUploadErrors.TOO_BIG;
  } else if (errorMessage?.includes(PhotoUploadErrors.WRONG_FILE_TYPE)) {
    return PhotoUploadErrors.WRONG_FILE_TYPE;
  } else {
    return PhotoUploadErrors.DEFAULT_ERROR;
  }
};

